import React, { useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import styles from "./Popup.module.scss";
import { Close } from "assets/icons";
import strings from "assets/strings";
import { getAllClassNames } from "helpers";


type IPopup = {
  closeIcon?: boolean;
  height?: number | string;
  width?: number;
  style?: React.CSSProperties;
  hideBackdrop?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
  isSidePopup?: boolean;
};

const Popup = forwardRef<HTMLDivElement, IPopup>(({ width, height, children, style, hideBackdrop, closeIcon = true, onClose, isSidePopup = false}: IPopup, ref) => {
  const onClickPopup = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  const backDrop = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => backDrop.current as HTMLDivElement);
  
  useEffect(() => {
    backDrop.current?.focus();
  }, []);

  // useEffect(() => {
  //   const focusableElements = backDrop.current?.querySelectorAll(
  //     'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  //   );
  //   const firstElement = focusableElements?.[0] as HTMLElement;
  //   const lastElement = focusableElements?.[focusableElements.length - 1] as HTMLElement;
  //   const trapFocus = (e: KeyboardEvent) => {
  //     if (e.key === 'Tab') {
  //       if (e.shiftKey) {
  //         if (document.activeElement === firstElement) {
  //           lastElement.focus();
  //           e.preventDefault();
  //         }
  //       } else {
  //         if (document.activeElement === lastElement) {
  //           firstElement.focus();
  //           e.preventDefault();
  //         }
  //       }
  //     }
  //     if (e.key === 'Escape') {
  //       onClose && onClose();
  //     }
  //   };

  //   if (firstElement) {
  //     firstElement?.focus();
  //   }

  //   document.addEventListener('keydown', trapFocus);
  //   return () => {
  //     document.removeEventListener('keydown', trapFocus);
  //   };
  // }, []);

  const handleCloseByEnter = (event: React.KeyboardEvent) => {   
    if (event.key === 'Enter'){
      event.preventDefault(); // Prevent default action
      onClose && onClose();
    }
  }

  return (
    <div onClick={onClose} className={`modal fade ${!hideBackdrop ? styles.backdrop : styles.noBackdrop} `} style={style} tabIndex={-1} aria-modal={true} role={"dialog"} ref={backDrop} aria-labelledby="modalTitle">
      <div onClick={onClickPopup} className={getAllClassNames([styles.popup, isSidePopup ? styles.sidePopUp : ''])} style={{ ...style, width, height }}>
        {closeIcon && <button type="button" className={styles.colseModal} onKeyDown={(e) => handleCloseByEnter(e)} onClick={onClose} aria-label={strings.globalStrings.close}>
          <Close className={styles.closeIcon} aria-hidden="true" />
        </button>}
        {children}
      </div>
    </div>
  );
});

export default Popup;